export default __webpack_public_path__ + "static/de-595e0c27997ea1710e4b11dc459c3f4f.png";